module.exports = __webpack_public_path__ + "media/images/athletes/104-b48ee0393542b9a184867289de8707b7.png";